export const countries = {
  LAC: "LAC",
  ARG: "Argentina",
  BOL: "Bolivia",
  BLZ: "Belice",
  BRA: "Brasil",
  BRB: "Barbados",
  CARIBE: "Caribe",
  CHL: "Chile",
  COL: "Colombia",
  CRI: "Costa Rica",
  DOM: "Rep. Dom.",
  ECU: "Ecuador",
  GTM: "Guatemala",
  HND: "Honduras",
  MEX: "México",
  NIC: "Nicaragua",
  PAN: "Panamá",
  PER: "Perú",
  PRY: "Paraguay",
  SLV: "El Salvador",
  TTO: "Trinidad y Tobago",
  URY: "Uruguay",
  VEN: "Venezuela",
  dates: "dates",
  data: "data",
  covid: "Covid",
  jobs: "Trabajo",
  health: "Salud",
  security: "Seguridad",
  services: "Servicios",
  women: "Género",
  gender: "Género",
};

export const countries_en = {
  PER: "Peru",
  PRY: "Paraguay",
  SLV: "El Salvador",
  TTO: "Trinidad and Tobago",
  URY: "Uruguay",
  VEN: "Venezuela",
  dates: "dates",
  data: "data",
  covid: "Covid",
  jobs: "Jobs",
  health: "Health",
  security: "Security",
  services: "Services",
  women: "Gender",
  gender: "Gender",
  LAC: "LAC",
  ARG: "Argentina",
  BOL: "Bolivia",
  BLZ: "Belize",
  BRA: "Brazil",
  BRB: "Barbados",
  CARIBE: "Caribbean",
  CHL: "Chile",
  COL: "Colombia",
  CRI: "Costa Rica",
  DOM: "Dom. Rep.",
  ECU: "Ecuador",
  GTM: "Guatemala",
  HND: "Honduras",
  MEX: "Mexico",
  NIC: "Nicaragua",
  PAN: "Panama",
 
};

export function getCountryName(code, language, isPNUD) {
  if (code === "LAC" && isPNUD) return "ALC";
  let names = language === "en" ? countries_en : countries;
  return names[code];
}
